module.exports = __webpack_public_path__ + "static/iphone-map-e5862f78fae43ea706a7c4dc73858e92.png";